<template>
    <b-overlay :show="loading" opacity="0.2" rounded="sm">
        <div class="border rounded p-1 mb-1">
            <div class="d-flex align-items-center justify-content-between mb-1">
                <div>
                    <h6 class="mb-25">Yıllık İzin Hakediş Başlangıcı</h6>
                    <!-- Hakediş normalde SGK işe giriş tarihinden işler; bu alan yalnızca
                         farklı bir tarihten başlatılması gerektiğinde doldurulur. -->
                    <small class="text-muted">
                        Yıllık izin hakedişi normalde SGK işe giriş tarihinden işler.
                        Farklı bir tarihten başlatılması gerekiyorsa buradan belirtin.
                        Bu tarih <strong>yalnızca yıllık izin hakedişini</strong> etkiler;
                        kıdem tazminatı ve çıkış evrakları SGK giriş tarihini kullanmaya devam eder.
                    </small>
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-md-4 mb-1 mb-md-0">
                    <label class="form-label">SGK İşe Giriş Tarihi</label>
                    <input class="form-control" :value="info.SGKEntryDateStr || '-'" disabled>
                </div>
                <div class="col-12 col-md-4 mb-1 mb-md-0">
                    <label class="form-label">Baz Alınacak Tarih</label>
                    <v-validator :errors="errors" parameter="BaseDate" :watch="form.BaseDate">
                        <v-date-picker v-model="form.BaseDate" placeholder="Baz Alınacak Tarih"></v-date-picker>
                    </v-validator>
                </div>
                <div class="col-12 col-md-4">
                    <label class="form-label">Hakediş Şu An Başlangıcı</label>
                    <input class="form-control font-weight-bolder"
                           :class="info.BaseDate ? 'text-warning' : ''"
                           :value="aktifBaslangic" disabled>
                </div>
                <div class="col-12 mt-1">
                    <label class="form-label">Açıklama <span class="text-danger">*</span></label>
                    <v-validator :errors="errors" parameter="Description" :watch="form.Description">
                        <textarea class="form-control resize-none" rows="2"
                                  v-model="form.Description"
                                  placeholder="Tarihin neden farklı belirlendiğini yazın"></textarea>
                    </v-validator>
                </div>
            </div>

            <div class="d-flex justify-content-end mt-1">
                <b-button v-if="info.BaseDate" variant="outline-danger" size="sm" class="mr-50"
                          :disabled="saving" v-on:click="remove">
                    Kaldır
                </b-button>
                <v-executer :loading="saving" :editing="!!info.BaseDate" :action="save"></v-executer>
            </div>
        </div>
    </b-overlay>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations'
import { BOverlay, BButton } from 'bootstrap-vue'

export default {
    components: { BOverlay, BButton },
    props: {
        id: { type: String, required: true }
    },
    data() {
        return {
            loading: false,
            saving: false,
            errors: {},
            info: {},
            form: {
                BaseDate: null,
                Description: null
            }
        }
    },
    computed: {
        // Hakedişin fiilen hangi tarihten işlediğini gösterir: kayıt varsa baz tarih,
        // yoksa SGK giriş tarihi. Kullanıcı "şu an hangisi geçerli" sorusunu buradan görür.
        aktifBaslangic() {
            if (this.info.BaseDateStr) return `${this.info.BaseDateStr} (baz tarih)`
            return this.info.SGKEntryDateStr ? `${this.info.SGKEntryDateStr} (SGK girişi)` : '-'
        }
    },
    methods: {
        get() {
            this.loading = true
            EmployeeOperationsApi.Employee.GetAnnualLeaveBaseDate(this.id).then(res => {
                this.info = res.data?.Data || {}
                this.form.BaseDate = this.info.BaseDate || null
                this.form.Description = this.info.Description || null
                this.loading = false
            }).catch(err => {
                this.loading = false
                this.$result(null, err)
            })
        },
        save() {
            this.saving = true
            this.errors = {}
            EmployeeOperationsApi.Employee.SaveAnnualLeaveBaseDate({
                EmployeeId: this.id,
                BaseDate: this.form.BaseDate,
                Description: this.form.Description
            }).then(res => {
                this.$result(res)
                this.saving = false
                if (res.data?.Success) {
                    this.get()
                    // Yıllık izin bakiyesi bu tarihe göre hesaplandığı için üst ekran tazelenir.
                    this.$emit('base-date-changed')
                }
            }).catch(err => {
                this.saving = false
                this.$result(null, err)
            })
        },
        remove() {
            this.saving = true
            EmployeeOperationsApi.Employee.DeleteAnnualLeaveBaseDate(this.id).then(res => {
                this.$result(res)
                this.saving = false
                if (res.data?.Success) {
                    this.form.BaseDate = null
                    this.form.Description = null
                    this.get()
                    this.$emit('base-date-changed')
                }
            }).catch(err => {
                this.saving = false
                this.$result(null, err)
            })
        }
    },
    mounted() {
        this.get()
    }
}
</script>
